import { fetcher } from '@commenda/utils';
import { RootFiCompany } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

const rootFiKeys = {
  FETCH_ROOT_FI_COMPANIES: 'FETCH_ROOT_FI_COMPANIES',
};

const getRootFiCompanies = async (businessEntityId: number) => {
  const response = await fetcher(
    `rootfi/companies?corporationId=${businessEntityId}`,
    {
      method: 'GET',
    }
  );

  if (!response.ok) throw new Error('Failed to fetch rootfi companies.');

  return (await response.json()) as { rootFiCompanies: RootFiCompany[] };
};

const useRootFiCompanies = (businessEntityId: number) => {
  if (!businessEntityId) return null;

  return useQuery({
    queryKey: [rootFiKeys.FETCH_ROOT_FI_COMPANIES, { businessEntityId }],
    queryFn: () => getRootFiCompanies(businessEntityId),
  });
};

export { useRootFiCompanies };
